import { render, staticRenderFns } from "./SCAOneOffPaymentForm.vue?vue&type=template&id=416020ac&scoped=true&"
import script from "./SCAOneOffPaymentForm.vue?vue&type=script&lang=js&"
export * from "./SCAOneOffPaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./SCAOneOffPaymentForm.vue?vue&type=style&index=0&id=416020ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416020ac",
  null
  
)

export default component.exports